import { styled } from '@mui/material';
import { CSSProperties, FC } from 'react';

import { useLayout, useProcessedBannerStore } from '../../../studentApp/hooks';
import { useProcessedWorkStore } from '../../../studentApp/hooks/useProcessedWorkStore';
import { BANNER_HEIGHT, BOX_SHADOW } from '../../constants';

import { HamburgerMenu } from './hamburger';
import { PointsTodayAndWeek } from './pointsTodayAndWeek';
import { WorkNameAndProgress } from './workNameAndProgress';

export const Banner: FC = () => {
  const { themeColor, themeColor2 } = useProcessedBannerStore();
  const { isLandscape } = useLayout();
  const { isTesting } = useProcessedWorkStore();

  return (
    <StyledBanner
      color={themeColor}
      color2={themeColor2}
      isLandscape={isLandscape}
      isTesting={isTesting}
    >
      <div style={leftStyle}>
        <WorkNameAndProgress />
      </div>

      {!isTesting && (
        <div style={middleStyle}>
          <PointsTodayAndWeek />
        </div>
      )}

      {!isTesting && <HamburgerMenu />}
    </StyledBanner>
  );
};

export const StyledBanner = styled('div')<{
  color: string;
  color2: string;
  isLandscape?: boolean;
  isTesting?: boolean;
}>(({ color, color2, isLandscape, isTesting }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: `${BANNER_HEIGHT}px`,
  minHeight: `${BANNER_HEIGHT}px`,
  paddingLeft: isLandscape || isTesting ? '20px' : '5px',
  paddingRight: isLandscape ? '20px' : '5px',
  background: `linear-gradient(to right, ${color2} 0%, ${color} 50%, ${color2} 100%)`,
  boxShadow: BOX_SHADOW,
  color: 'white',
}));

const leftStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'left',
};

const middleStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
};
